import { IInitMainThreadConfig, IPortServiceMap } from '../common/interface/services.interface';
import { MainThreadTransport } from '@tencent/slide-sdk-portal/src/transport/common/main-thread-transport';
import { Request } from './services/request';
import { Util } from './services/util';
import { DetectPortalClient } from '../common/portal';

export function initInMainThead(initConfig: IInitMainThreadConfig) {
    const { sharedWorker } = initConfig;
    const client = new DetectPortalClient<IPortServiceMap>(new MainThreadTransport(sharedWorker.port));
    const syncManager = client.service('workerSyncManager');
    const portClientManager = client.service('workerPortClientManager');
    client.register('mainThreadUtil', Util.getInstance());
    client.register('mainThreadRequest', Request.getInstance());
    client.register('mainThreadDocInfo', initConfig.docInfoProvider as unknown as IPortServiceMap['mainThreadDocInfo']);
    client.register('mainThreadActionProvider', initConfig.actionProvider as unknown as IPortServiceMap['mainThreadActionProvider']);

    return { syncManager, portClientManager };
}
